import { Type } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

export type RouteComponentSelector = (currentRoute: ActivatedRouteSnapshot) => boolean;

export function resolveRouteComponentSelector(
  componentTypeOrSelector: Type<unknown> | RouteComponentSelector
): RouteComponentSelector {
  return isConstructor(componentTypeOrSelector)
    ? (snapshot: ActivatedRouteSnapshot) => snapshot.component === componentTypeOrSelector
    : componentTypeOrSelector;
}

function isConstructor(value: unknown): value is Type<unknown> {
  return typeof value === 'function' && !!value.prototype && value.prototype.constructor === value;
}
